import { render } from "./ImportDetailSettingsTab.vue?vue&type=template&id=d211a0bc&scoped=true"
import script from "./ImportDetailSettingsTab.vue?vue&type=script&lang=js"
export * from "./ImportDetailSettingsTab.vue?vue&type=script&lang=js"

import "./ImportDetailSettingsTab.vue?vue&type=style&index=0&id=d211a0bc&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d211a0bc"]])

export default __exports__